<template>
    <div>
        <v-hover v-slot:default="{ hover }">
            <v-btn
                v-if="!comentarios"

                color="#55855f"
                dark
                absolute
                bottom=""
                right=""
                @click="comentarios=!comentarios"
            >
                <v-icon>mdi-comment-text-outline</v-icon>
                Enviar Comentarios
            </v-btn>
        </v-hover>
        <v-overlay :value="comentarios">
            <v-card
                height="500"
                width="600"
                light=""
                tile
            >
                <v-card-title class="title font-weight-regular justify-space-between">
                    <p>Envío de comentario</p>
                    <v-spacer />
                    <v-btn
                        icon
                        flat
                        tile
                        @click="comentarios = false"
                    >
                        <v-icon>
                            mdi-close
                        </v-icon>
                    </v-btn>
                </v-card-title>
                <v-card-text>
                    <v-container>
                        <v-window v-model="ventana">
                            <v-window-item :value="1">
                                <p class="headline">
                                    Que te parecio el servicio ??????
                                </p>

                                <v-rating
                                    :value="4"

                                    color="orange"
                                    background-color="orange"
                                    hover
                                    class="mr-2"
                                />
                            </v-window-item>

                            <v-window-item :value="2">
                                <v-card-text>
                                    <v-textarea
                                        solo=""
                                        label="Deja aquí tú comentario"
                                        hint="Escribe tu comentario"
                                    />
                                    <v-text-field
                                        solo=""
                                        label="Correo"
                                        type="text"
                                    />
                                </v-card-text>
                            </v-window-item>

                            <v-window-item :value="3">
                                <div class="pa-4 text-center">
                                    <h3 class="title font-weight-light mb-2">
                                        Gracias por tu opinion
                                    </h3>
                                </div>
                            </v-window-item>
                        </v-window>
                    </v-container>
                </v-card-text>
                <v-spacer />
                <v-card-actions>
                    <v-spacer />
                    <v-btn

                        color="primary"
                        depressed
                        @click="eventoVentana"
                    >
                        {{ ventana===3 ? 'Cerrar' : 'Siguiente' }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-overlay>
    </div>
</template>
<script>
export default {
  props: {
    comentarios: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
      ventana: 1
    }
  },
  methods: {
    eventoVentana () {
      if (this.ventana === 3) {
        this.comentarios = false
        this.ventana = 1
      } else { this.ventana++ }
    }
  }
}
</script>
